export default "__VITE_ASSET__BbfdEReD__"